/**
 * Identifiant partenaire pour les routes API (ex. /partners/{id}/…).
 * Priorité alignée sur partnerReducer et AdminPartner : user_uuid → id → partner_id.
 */
export const resolvePartnerApiId = (partner) => {
    if (!partner || typeof partner !== 'object') return null;

    const candidates = [partner.user_uuid, partner.id, partner.partner_id];
    const resolved = candidates.find(
        (value) => value != null && String(value).trim() !== ''
    );

    return resolved != null ? String(resolved).trim() : null;
};

export const getPartnerDisplayName = (partner) => {
    if (!partner) return 'N/A';

    if (partner.company_name && String(partner.company_name).trim()) {
        return String(partner.company_name).trim();
    }

    const fullName = [
        partner.partner_first_name || partner.first_name,
        partner.partner_last_name || partner.last_name,
    ]
        .filter((part) => part != null && String(part).trim() !== '')
        .map((part) => String(part).trim())
        .join(' ');

    if (fullName) return fullName;

    if (partner.email && String(partner.email).trim()) {
        return String(partner.email).trim();
    }

    return 'N/A';
};

/** Options uniques triées pour les listes déroulantes partenaire. */
export const buildPartnerSelectOptions = (partners = []) => {
    const seen = new Set();
    const options = [];

    partners.forEach((partner) => {
        const id = resolvePartnerApiId(partner);
        if (!id || seen.has(id)) return;
        seen.add(id);
        options.push({
            id,
            label: getPartnerDisplayName(partner),
        });
    });

    return options.sort((a, b) => a.label.localeCompare(b.label, 'fr'));
};
